/* ==========================================================================
   TP 2.0 — Quick-add

   Ett enda variantark för hela butiken. Produktkortets köpknapp:

     · en variant      → läggs direkt i korgen via TPCart
     · flera varianter → öppnar det här arket
     · "Prenumerera"   → öppnar arket i prenumerationsläge (data-qa-mode=
                         "subscribe"): variant + leveransintervall ur
                         Shopifys prenumerationsplan, läggs i korgen med
                         selling_plan via TPCart.
     · klockan (slut)  → öppnar arket i bevakningsläge (data-qa-mode=
                         "restock"): mejlfält, samma bevakning som på
                         produktsidan.

   Arket är ett bottom sheet på mobil och en centrerad dialog på desktop.
   Innehållet hämtas från /products/<handle>.js första gången och cachas i
   minnet. All korglogik går via window.TPCart — ingen egen /cart/add.js.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__tpQuickAddReady) return;
  window.__tpQuickAddReady = true;

  var CACHE = {};
  var root = null;
  var state = { product: null, selection: [], trigger: null, open: false, mode: 'buy', origin: 'buy', plan: null };

  /* ---- Hjälpare ---------------------------------------------------------- */
  function esc(value) {
    var div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  function money(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'SEK';
    try {
      /* Hela kronor utan decimaler; prenumerationspriser (t.ex. 449,10 kr)
         visas med ören i stället för att avrundas. */
      var whole = Math.round(cents) % 100 === 0;
      return new Intl.NumberFormat('sv-SE', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: whole ? 0 : 2
      }).format(cents / 100);
    } catch (error) {
      return Math.round(cents / 100) + ' kr';
    }
  }

  function getProduct(handle) {
    if (CACHE[handle]) return Promise.resolve(CACHE[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Kunde inte hämta produkten');
        return response.json();
      })
      .then(function (product) {
        CACHE[handle] = product;
        return product;
      });
  }

  /* ---- Arkets skal ------------------------------------------------------- */
  function build() {
    if (root) return root;

    root = document.createElement('div');
    root.className = 'tp-qa';
    root.setAttribute('hidden', '');
    root.innerHTML =
      /* Knapp, inte div: temats bas-CSS döljer tomma div-element
         (div:empty { display: none }), och en klickbar yta ska ändå
         vara en knapp. */
      '<button type="button" class="tp-qa__scrim" data-qa-close aria-label="Stäng"></button>' +
      '<div class="tp-qa__panel" role="dialog" aria-modal="true" aria-label="Välj alternativ">' +
        '<button type="button" class="tp-qa__grab" data-qa-close aria-label="Stäng"></button>' +
        '<button type="button" class="tp-qa__close" data-qa-close aria-label="Stäng">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg>' +
        '</button>' +
        '<div class="tp-qa__body" data-qa-body></div>' +
      '</div>';

    document.body.appendChild(root);

    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-qa-close]')) { close(); return; }

      var value = event.target.closest('[data-qa-value]');
      if (value && !value.disabled) {
        state.selection[Number(value.dataset.qaOption)] = value.dataset.qaValue;
        paint();
        return;
      }

      var plan = event.target.closest('[data-qa-plan]');
      if (plan) {
        state.plan = Number(plan.dataset.qaPlan);
        paint();
        return;
      }

      if (event.target.closest('[data-qa-onetime]')) { state.mode = 'buy'; paint(); return; }
      if (event.target.closest('[data-qa-subscribe]')) { state.mode = 'subscribe'; paint(); return; }

      var add = event.target.closest('[data-qa-add]');
      if (add) submit(add);
    });

    root.addEventListener('submit', function (event) {
      var form = event.target;
      if (form && form.closest && form.closest('[data-qa-restock]')) sendRestock(event, form);
    });

    document.addEventListener('keydown', function (event) {
      if (!state.open) return;
      if (event.key === 'Escape') { close(); return; }
      if (event.key === 'Tab') trapFocus(event);
    });

    return root;
  }

  function trapFocus(event) {
    var focusables = root.querySelectorAll('button:not([disabled]), a[href], input:not([type="hidden"])');
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  /* ---- Variantlogik ------------------------------------------------------ */
  function variantFor(selection) {
    var variants = state.product.variants;
    for (var i = 0; i < variants.length; i++) {
      var match = true;
      for (var o = 0; o < selection.length; o++) {
        if (variants[i].options[o] !== selection[o]) { match = false; break; }
      }
      if (match) return variants[i];
    }
    return null;
  }

  /* Ett värde är valbart om det finns minst en variant med det värdet som
     stämmer med de val kunden redan gjort i tidigare optionsgrupper. */
  function valueAvailable(optionIndex, value) {
    return state.product.variants.some(function (variant) {
      if (variant.options[optionIndex] !== value) return false;
      if (!variant.available) return false;
      for (var o = 0; o < optionIndex; o++) {
        if (state.selection[o] && variant.options[o] !== state.selection[o]) return false;
      }
      return true;
    });
  }

  function valueExists(optionIndex, value) {
    return state.product.variants.some(function (variant) {
      if (variant.options[optionIndex] !== value) return false;
      for (var o = 0; o < optionIndex; o++) {
        if (state.selection[o] && variant.options[o] !== state.selection[o]) return false;
      }
      return true;
    });
  }

  /* ---- Rendering --------------------------------------------------------- */
  /* Butikens optionsnamn är delvis felinmatade — flera produkter har
     produktnamnet som optionsnamn ("AS Nutrition - EAA") i stället för
     "Smak". Kända namn används som de är; okända faller tillbaka på
     "Välj alternativ" i stället för att skriva ut skräpet. */
  var KNOWN_OPTIONS = ['smak', 'storlek', 'size', 'färg', 'color', 'vikt', 'antal',
                       'modell', 'längd', 'styrka', 'nivå', 'variant', 'utförande'];

  /* Samma farglexikon som snippets/tp2-color-token.liquid. Det gar inte att
     dela mellan Liquid och JS, sa de tva maste hallas i takt. Vardena
     beskriver fysiska produktfarger och ar inte designtokens. */
  var COLOR_WORDS = [
    ['svart', '#141619'], ['black', '#141619'],
    ['marin', '#1b2a44'], ['navy', '#1b2a44'],
    ['ljusbl', '#7fb4de'], ['light blue', '#7fb4de'],
    ['blå', '#1f4f8f'], ['bla', '#1f4f8f'], ['blue', '#1f4f8f'],
    ['bordeaux', '#6b1f2e'], ['burgund', '#6b1f2e'], ['burdeos', '#6b1f2e'], ['vinr', '#6b1f2e'],
    ['rosa', '#e58ca8'], ['pink', '#e58ca8'],
    ['röd', '#c02a2a'], ['rod', '#c02a2a'], ['red', '#c02a2a'],
    ['orange', '#e2701f'],
    ['gul', '#e8c33c'], ['yellow', '#e8c33c'],
    ['lime', '#b6e02a'], ['neon', '#b6e02a'],
    ['turkos', '#2aa7a2'], ['turquoise', '#2aa7a2'], ['teal', '#2aa7a2'],
    ['oliv', '#6a7047'], ['khaki', '#6a7047'], ['camo', '#6a7047'],
    ['grön', '#2f7d44'], ['gron', '#2f7d44'], ['green', '#2f7d44'],
    ['lila', '#6a4a9c'], ['purple', '#6a4a9c'],
    ['brun', '#6a4a35'], ['brown', '#6a4a35'],
    ['beige', '#d9cdba'], ['sand', '#d9cdba'], ['natur', '#d9cdba'],
    ['guld', '#bfa145'], ['gold', '#bfa145'],
    ['silver', '#c2c6c9'],
    ['grå', '#8a9199'], ['gra', '#8a9199'], ['grey', '#8a9199'], ['gray', '#8a9199'],
    ['vit', '#f4f5f6'], ['white', '#f4f5f6']
  ];

  function colorFor(value) {
    var v = String(value || '').toLowerCase();
    for (var i = 0; i < COLOR_WORDS.length; i++) {
      if (v.indexOf(COLOR_WORDS[i][0]) > -1) return COLOR_WORDS[i][1];
    }
    return '';
  }

  /* Forsta varianten med det har vardet som har en egen bild. */
  function valueImage(optionIndex, value) {
    var hit = null;
    state.product.variants.some(function (variant) {
      if (variant.options[optionIndex] !== value) return false;
      if (!variant.featured_image || !variant.featured_image.src) return false;
      hit = variant.featured_image.src;
      return true;
    });
    return hit;
  }

  /* Samma tre uttryck som produktsidan: farg blir cirkel, smak blir bild,
     allt annat blir knapp. Bada bildvagarna faller tillbaka pa knappar om
     datan inte racker — hellre knappar an halva rader. */
  function groupStyle(name, index, list) {
    var n = String(name || '').toLowerCase();
    var isColor = n.indexOf('färg') > -1 || n.indexOf('farg') > -1 ||
                  n.indexOf('color') > -1 || n.indexOf('colour') > -1;

    if (isColor) {
      var allColors = list.every(function (v) { return colorFor(v) !== ''; });
      if (allColors) return 'color';
      return 'button';
    }

    if (list.length < 2 || list.length > 16) return 'button';
    var images = list.map(function (v) { return valueImage(index, v); });
    if (images.some(function (src) { return !src; })) return 'button';
    var distinct = images.some(function (src) { return src !== images[0]; });
    if (!distinct) return 'button';

    var isFlavor = n.indexOf('smak') > -1 || n.indexOf('flavor') > -1 || n.indexOf('flavour') > -1;
    return isFlavor || index === 0 ? 'media' : 'button';
  }

  function optionLabel(name) {
    var n = String(name || '').toLowerCase().trim();
    for (var i = 0; i < KNOWN_OPTIONS.length; i++) {
      if (n === KNOWN_OPTIONS[i] || n.indexOf(KNOWN_OPTIONS[i]) > -1) {
        if (KNOWN_OPTIONS[i] === 'size') return 'Välj storlek';
        if (KNOWN_OPTIONS[i] === 'color') return 'Välj färg';
        return 'Välj ' + KNOWN_OPTIONS[i];
      }
    }
    return 'Välj alternativ';
  }

  /* Paket har ett val per ingående produkt, och optionsnamnet bär då
     produkten: "Simglasögon - Open Water (Färg)", "SWIMCAP (Färg)". Utan
     den delen står det bara "Välj färg" två gånger och kunden vet inte
     vilken produkt valet gäller. Namnet före parentesen visas därför
     ovanför etiketten. Bara mönstret "Produkt (känt val)" räknas — ett
     namn som "AS Nutrition - EAA" utan parentes är skräp och visas inte. */
  function optionPart(name) {
    var m = String(name || '').match(/^(.+?)\s*\(([^)]+)\)\s*$/);
    if (!m) return '';
    var inner = m[2].toLowerCase().trim();
    var known = KNOWN_OPTIONS.some(function (k) { return inner === k || inner.indexOf(k) > -1; });
    if (!known) return '';
    var part = m[1].trim().replace(/\s+-\s+/g, ' – ');
    if (part.length > 3 && part === part.toUpperCase()) {
      part = part.charAt(0) + part.slice(1).toLowerCase();
    }
    return part;
  }

  /* ---- Prenumeration ------------------------------------------------------ */
  /* Planerna kommer från /products/<handle>.js: selling_plan_groups ger
     namn och intervall, variantens selling_plan_allocations ger priset.
     Butikens planer heter "Leverera varje månad", "Leverera var 2:e
     månad" osv. */
  function monthsFrom(text) {
    var t = String(text || '').toLowerCase();
    if (t.indexOf('veck') > -1 || t.indexOf('week') > -1 || t.indexOf('dag') > -1) return 0;
    var m = t.match(/(\d+)/);
    return m ? Number(m[1]) : 1;
  }

  function planLabel(text, months) {
    var t = String(text || '').toLowerCase();
    if (months && (t.indexOf('mån') > -1 || t.indexOf('man') > -1 || t.indexOf('month') > -1)) {
      if (months === 1) return 'Varje månad';
      if (months === 2) return 'Varannan månad';
      if (months === 3) return 'Var tredje månad';
      return 'Var ' + months + ':e månad';
    }
    var clean = String(text || '').replace(/^leverera\s+/i, '');
    return clean.charAt(0).toUpperCase() + clean.slice(1);
  }

  function plansFor(variant) {
    var product = state.product;
    if (!variant || !product || !product.selling_plan_groups || !product.selling_plan_groups.length) return [];
    var byId = {};
    product.selling_plan_groups.forEach(function (group) {
      (group.selling_plans || []).forEach(function (plan) { byId[plan.id] = plan; });
    });
    return (variant.selling_plan_allocations || []).map(function (alloc) {
      var plan = byId[alloc.selling_plan_id];
      if (!plan) return null;
      var value = (plan.options && plan.options[0] && plan.options[0].value) || plan.name || '';
      var months = monthsFrom(value);
      return {
        id: alloc.selling_plan_id,
        label: planLabel(value, months),
        months: months,
        price: alloc.per_delivery_price || alloc.price
      };
    }).filter(Boolean);
  }

  /* Besparing per år, avrundad nedåt till hela kronor så att siffran
     aldrig lovar mer än planen ger. */
  function yearlySaving(variant, plan) {
    if (!plan.months) return 0;
    var perDelivery = variant.price - plan.price;
    if (perDelivery <= 0) return 0;
    return Math.floor((perDelivery * (12 / plan.months)) / 100) * 100;
  }

  /* ---- Bevakning ---------------------------------------------------------
     Klockan bredvid "Slut i lager" på kortet öppnar arket i bevakningsläge
     (data-qa-mode="restock"). Samma bevakning som på produktsidan:
     Shopifys eget kundformulär med taggarna "bevakning" och
     "bevakning-<produkt>", skickat genom Shopifys skräppostskydd via
     tp-customer-form.js. Mejlen skickas av Shopify Flow ("TP Bevakning –
     bekräftelse" och "TP Bevakning – tillbaka i lager"). */
  function loadCustomerForm() {
    if (window.TPCustomerForm || document.querySelector('script[src*="tp-customer-form.js"]')) return;
    var own = document.querySelector('script[src*="tp-quick-add.js"]');
    if (!own) return;
    var script = document.createElement('script');
    script.src = own.src.replace('tp-quick-add.js', 'tp-customer-form.js');
    script.defer = true;
    document.head.appendChild(script);
  }

  function paintRestock() {
    var product = state.product;
    var body = root.querySelector('[data-qa-body]');
    var image = product.featured_image || '';
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    body.innerHTML =
      '<div class="tp-qa__head">' +
        (image ? '<span class="tp-qa__thumb"><img src="' + esc(image) + '" alt="" loading="lazy"></span>' : '') +
        '<div class="tp-qa__headtext">' +
          '<p class="tp-qa__title">' + esc(product.title) + '</p>' +
          '<p class="tp-qa__restock-state">Slut i lager</p>' +
        '</div>' +
      '</div>' +
      '<div class="tp-qa__restock" data-qa-restock>' +
        '<p class="tp-qa__restock-lead">Skriv in din mejladress, så hör vi av oss när produkten finns i lager igen.</p>' +
        '<form method="post" action="' + esc(base) + 'contact#TpQaRestockForm" id="TpQaRestockForm" accept-charset="UTF-8" class="tp-qa__restock-form" data-tp-customer-form="true">' +
          '<input type="hidden" name="form_type" value="customer">' +
          '<input type="hidden" name="utf8" value="✓">' +
          '<input type="hidden" name="contact[tags]" value="bevakning, bevakning-' + esc(product.handle) + '">' +
          '<label class="visually-hidden" for="TpQaRestockEmail">E-postadress</label>' +
          '<div class="tp-qa__restock-row">' +
            '<input id="TpQaRestockEmail" class="tp-qa__restock-input" type="email" name="contact[email]" placeholder="din@mejl.se" autocomplete="email" autocorrect="off" autocapitalize="off" spellcheck="false" required>' +
            '<button type="submit" class="tp-btn tp-btn--primary tp-qa__restock-submit" data-qa-restock-submit>Bevaka</button>' +
          '</div>' +
        '</form>' +
        '<p class="tp-qa__restock-done" data-qa-restock-done hidden>Tack — vi hör av oss så fort varan är tillbaka.</p>' +
        '<p class="tp-qa__restock-error" data-qa-restock-error hidden>Det gick inte att spara adressen just nu. Försök igen om en stund.</p>' +
        '<p class="tp-qa__restock-fine">Vi använder adressen för att meddela dig om den här produkten och för våra utskick. Du kan avsluta när du vill.</p>' +
      '</div>' +
      '<div class="tp-qa__foot">' +
        '<a class="tp-qa__more" href="' + esc(product.url) + '">Läs mer om produkten</a>' +
      '</div>';

    var panel = root.querySelector('.tp-qa__panel');
    if (panel) panel.setAttribute('aria-label', 'Bevaka produkten');
  }

  /* Utan tp-customer-form.js (inte laddad än) skickas formuläret på
     vanligt sätt, genom Shopifys skräppostskydd. */
  function sendRestock(event, form) {
    if (!window.TPCustomerForm) return;
    event.preventDefault();
    if (typeof form.reportValidity === 'function' && !form.reportValidity()) return;

    var box = form.closest('[data-qa-restock]');
    var button = box.querySelector('[data-qa-restock-submit]');
    var done = box.querySelector('[data-qa-restock-done]');
    var error = box.querySelector('[data-qa-restock-error]');

    if (button) {
      button.disabled = true;
      button.textContent = 'Skickar…';
    }
    if (error) error.hidden = true;

    window.TPCustomerForm.post(form)
      .then(function () {
        form.hidden = true;
        if (done) done.hidden = false;
      })
      .catch(function () {
        if (error) error.hidden = false;
        if (button) {
          button.disabled = false;
          button.textContent = 'Bevaka';
        }
      });
  }

  function paint() {
    if (state.mode === 'restock') { paintRestock(); return; }
    var product = state.product;
    var body = root.querySelector('[data-qa-body]');
    var variant = variantFor(state.selection);
    var priceVariant = variant || product.variants[0];
    var onSale = priceVariant.compare_at_price && priceVariant.compare_at_price > priceVariant.price;
    var image = (variant && variant.featured_image && variant.featured_image.src) || product.featured_image || '';

    var plans = state.mode === 'subscribe' ? plansFor(priceVariant) : [];
    var sub = state.mode === 'subscribe' && plans.length > 0;
    var activePlan = null;
    if (sub) {
      activePlan = plans.filter(function (p) { return p.id === state.plan; })[0] || plans[0];
      state.plan = activePlan.id;
    }
    var subPct = activePlan ? Math.round(((priceVariant.price - activePlan.price) * 100) / priceVariant.price) : 0;

    /* Produkter utan riktiga val har en enda variant "Default Title" —
       då finns inget att välja och gruppen visas inte. */
    var singleDefault = product.variants.length === 1 && /default title/i.test(product.variants[0].title || '');

    var groups = singleDefault ? '' : product.options.map(function (option, index) {
      var name = typeof option === 'string' ? option : option.name;
      var list = [];
      product.variants.forEach(function (v) {
        if (list.indexOf(v.options[index]) === -1) list.push(v.options[index]);
      });

      var style = groupStyle(name, index, list);

      return '<div class="tp-qa__group tp-qa__group--' + style + '">' +
          '<p class="tp-qa__group-label">' +
            (optionPart(name) ? '<span class="tp-qa__group-part">' + esc(optionPart(name)) + '</span>' : '') +
            esc(optionLabel(name)) + '</p>' +
          '<div class="tp-qa__values">' +
            list.map(function (value) {
              var exists = valueExists(index, value);
              var available = valueAvailable(index, value);
              var selected = state.selection[index] === value;
              var inner;

              if (style === 'media') {
                inner = '<span class="tp-qa__value-media"><img src="' +
                  esc(valueImage(index, value)) + '" alt="" loading="lazy"></span>' +
                  '<span class="tp-qa__value-name">' + esc(value) + '</span>';
              } else if (style === 'color') {
                inner = '<span class="tp-qa__value-dot" style="--tp2-swatch: ' +
                  esc(colorFor(value)) + '"></span>' +
                  '<span class="tp-qa__value-name">' + esc(value) + '</span>';
              } else {
                inner = esc(value);
              }

              return '<button type="button" class="tp-qa__value' +
                (selected ? ' is-selected' : '') +
                (available ? '' : ' is-unavailable') +
                '" data-qa-value="' + esc(value) + '" data-qa-option="' + index + '"' +
                (exists ? '' : ' disabled') +
                ' aria-pressed="' + (selected ? 'true' : 'false') + '">' +
                inner +
                (available ? '' : '<span class="tp-qa__value-note">Slut</span>') +
                '</button>';
            }).join('') +
          '</div>' +
        '</div>';
    }).join('');

    var planGroup = '';
    if (sub) {
      planGroup =
        '<div class="tp-qa__group tp-qa__group--plans">' +
          '<p class="tp-qa__group-label">Hur ofta?</p>' +
          '<div class="tp-qa__plans" role="radiogroup" aria-label="Leveransintervall">' +
            plans.map(function (plan) {
              var selected = plan.id === activePlan.id;
              var saving = yearlySaving(priceVariant, plan);
              return '<button type="button" class="tp-qa__plan' + (selected ? ' is-selected' : '') + '"' +
                ' data-qa-plan="' + plan.id + '" role="radio" aria-checked="' + (selected ? 'true' : 'false') + '">' +
                  '<span class="tp-qa__plan-name">' + esc(plan.label) + '</span>' +
                  '<span class="tp-qa__plan-price">' + money(plan.price) + ' per leverans</span>' +
                  (saving > 0 ? '<span class="tp-qa__plan-save">Spara ' + money(saving) + ' per år</span>' : '') +
                '</button>';
            }).join('') +
          '</div>' +
        '</div>';
    }

    var canAdd = variant && variant.available;
    var buttonText = !variant ? 'Välj alternativ' : (variant.available ? (sub ? 'Starta prenumeration' : 'Lägg i varukorgen') : 'Slut i lager');

    var priceHtml = sub
      ? '<p class="tp-qa__price is-sub">' + money(activePlan.price) +
          '<span class="tp-qa__sub-chip">−' + subPct + ' %</span></p>' +
        '<p class="tp-qa__price-note">per leverans · engångsköp ' + money(priceVariant.price) + '</p>'
      : '<p class="tp-qa__price' + (onSale ? ' is-sale' : '') + '">' +
          money(priceVariant.price) +
          (onSale ? '<s>' + money(priceVariant.compare_at_price) + '</s>' : '') +
        '</p>';

    var switchHtml = '';
    if (state.origin === 'subscribe' && variant && variant.available) {
      if (sub) {
        switchHtml = '<p class="tp-qa__sub-note">Ingen bindningstid. Pausa, ändra eller avsluta i Mitt konto när du vill.</p>' +
          '<button type="button" class="tp-qa__switch" data-qa-onetime>Köp en gång för ' + money(priceVariant.price) + ' i stället</button>';
      } else if (plansFor(priceVariant).length) {
        switchHtml = '<button type="button" class="tp-qa__switch" data-qa-subscribe>Prenumerera och spara i stället</button>';
      }
    }

    body.innerHTML =
      '<div class="tp-qa__head">' +
        (image ? '<span class="tp-qa__thumb"><img src="' + esc(image) + '" alt="" loading="lazy"></span>' : '') +
        '<div class="tp-qa__headtext">' +
          '<p class="tp-qa__title">' + esc(product.title) + '</p>' +
          priceHtml +
        '</div>' +
      '</div>' +
      groups +
      planGroup +
      '<div class="tp-qa__foot">' +
        '<button type="button" class="tp-btn tp-btn--primary tp-qa__add" data-qa-add' +
          (canAdd ? '' : ' disabled') + '>' + buttonText + '</button>' +
        switchHtml +
        '<a class="tp-qa__more" href="' + esc(product.url) + '">Läs mer om produkten</a>' +
      '</div>';

    var panel = root.querySelector('.tp-qa__panel');
    if (panel) panel.setAttribute('aria-label', sub ? 'Välj hur ofta' : 'Välj alternativ');
  }

  /* ---- Öppna, stäng, lägg till ------------------------------------------- */
  function open(handle, trigger) {
    build();
    state.trigger = trigger || null;
    var qaMode = trigger && trigger.dataset ? trigger.dataset.qaMode : '';
    state.origin = qaMode === 'subscribe' || qaMode === 'restock' ? qaMode : 'buy';
    state.mode = state.origin;
    if (state.mode === 'restock') loadCustomerForm();
    // Räknaren på prenumerationssidan skickar med valt intervall.
    state.plan = trigger && trigger.dataset && trigger.dataset.qaPlan ? Number(trigger.dataset.qaPlan) : null;

    root.removeAttribute('hidden');
    root.classList.add('is-loading');
    document.body.classList.add('tp-qa-open');
    state.open = true;
    /* Ett lager åt gången (P2-01): sök, meny, varukorg och popup stänger sig. */
    document.dispatchEvent(new CustomEvent('tp:layer-open', { detail: { name: 'quick-add' } }));
    /* Nästa bildruta, så att övergången faktiskt animeras */
    window.requestAnimationFrame(function () { root.classList.add('is-open'); });

    root.querySelector('[data-qa-body]').innerHTML = '<p class="tp-qa__loading">Hämtar alternativ …</p>';

    getProduct(handle).then(function (product) {
      state.product = product;
      state.selection = [];

      /* Förvälj första tillgängliga variantens värden, så att kunden ofta
         bara behöver ändra det som spelar roll. */
      var first = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
      if (first) state.selection = first.options.slice(0, product.options.length);

      root.classList.remove('is-loading');
      paint();

      var firstButton = root.querySelector('.tp-qa__value:not([disabled]), .tp-qa__plan, [data-qa-add]') || root.querySelector('.tp-qa__close');
      if (firstButton) firstButton.focus({ preventScroll: true });
    }).catch(function () {
      root.classList.remove('is-loading');
      root.querySelector('[data-qa-body]').innerHTML =
        '<p class="tp-qa__loading">Kunde inte hämta produktens alternativ. Öppna produktsidan i stället.</p>';
    });
  }

  /* options.quiet: ett annat lager tar över och flyttar själv fokus. */
  function close(options) {
    if (!root || !state.open) return;
    state.open = false;
    root.classList.remove('is-open');
    document.body.classList.remove('tp-qa-open');

    var done = function () {
      if (state.open) return;
      root.setAttribute('hidden', '');
    };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) done();
    else window.setTimeout(done, 220);

    if (!(options && options.quiet) && state.trigger && document.contains(state.trigger)) state.trigger.focus({ preventScroll: true });
  }

  document.addEventListener('tp:layer-open', function (event) {
    if (event.detail && event.detail.name !== 'quick-add') close({ quiet: true });
  });

  function submit(button) {
    var variant = variantFor(state.selection);
    if (!variant || !variant.available) return;
    if (!window.TPCart || typeof window.TPCart.add !== 'function') {
      window.location.href = state.product.url + '?variant=' + variant.id +
        (state.mode === 'subscribe' && state.plan ? '&selling_plan=' + state.plan : '');
      return;
    }

    var subscribe = state.mode === 'subscribe' && state.plan && plansFor(variant).some(function (p) { return p.id === state.plan; });
    var item = subscribe
      ? { id: Number(variant.id), quantity: 1, selling_plan: Number(state.plan) }
      : Number(variant.id);

    button.classList.add('tp-is-loading');
    button.disabled = true;

    Promise.resolve(window.TPCart.add(item, { source: subscribe ? 'quick-add-subscription' : 'quick-add', trigger: state.trigger || button }))
      .then(function () { close(); })
      .catch(function () {
        button.textContent = 'Försök igen';
      })
      .then(function () {
        button.classList.remove('tp-is-loading');
        button.disabled = false;
      });
  }

  /* ---- Kortens knapp ----------------------------------------------------- */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-tp2-quick-add]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();

    var handle = button.dataset.handle;
    if (!handle) {
      var card = button.closest('[data-product-handle]');
      handle = card ? card.dataset.productHandle : '';
    }
    if (!handle) return;

    open(handle, button);
  });

  window.TPQuickAdd = { open: open, close: close };
})();
